import { createSelector } from 'reselect'
import { PASSPORT_CARD_UTM_CAMPAIGN } from 'constants/insurance'
import { isCruiseItem, isTourV2Item } from 'lib/checkout/checkoutUtils'
import { isPassportCardStartDateWithinAllowedRange } from 'checkout/Components/CheckoutSteps/Review/PassportCardInsurance/passportCardUtils'
import getInsuranceDatesFromCart from './getInsuranceDatesFromCart'
import { hasPassportCardEligibleItems } from '../view/itemViews/getPassportCardQuoteItems'

export function isPassportCardUtmCampaign(utmCampaign: string | undefined): boolean {
  return utmCampaign?.toLowerCase() === PASSPORT_CARD_UTM_CAMPAIGN
}

// Preserve the legacy campaign entry point for eligible hotel and experience
// checkouts. Tours and cruises deliberately bypass this selector so their
// availability is controlled exclusively by the Optimizely feature flag.
const isPassportCardInsuranceSupportedViaCampaign = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isPassportCardUtmCampaign(state.utm.campaign),
  (state: App.State) => getInsuranceDatesFromCart(state)?.startDate,
  (state: App.State) => hasPassportCardEligibleItems(state),
  (state: App.State) => state.checkout.cart.items,
  (
    regionCode,
    isCampaign,
    checkoutStartDate,
    cartHasEligibleItems,
    cartItems,
  ): boolean => {
    if (!isCampaign) return false
    if (cartItems.some(item => isTourV2Item(item) || isCruiseItem(item))) return false
    if (regionCode !== 'AU') return false
    if (!isPassportCardStartDateWithinAllowedRange(checkoutStartDate)) return false
    return cartHasEligibleItems
  },
)

export default isPassportCardInsuranceSupportedViaCampaign
